import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import './styles/landing-v2.scss'
import { buildFallbackAppStoreURL, buildFallbackPlayStoreURL, generateOneLinkClickURL, IVY_ONELINK_TEMPLATE_URL } from '../../../utils/onelinkSmartScript'
import SiteHeader from './components/SiteHeader'
import Hero from './components/Hero'
import HowItWorksSection from './components/HowItWorksSection'
import ForSinglesSection from './components/ForSinglesSection'
import ForVenuesSection from './components/ForVenuesSection'
import TrustSection from './components/TrustSection'
import AroundChicagoSection from './components/AroundChicagoSection'
import AboutSection from './components/AboutSection'
import DownloadSection from './components/DownloadSection'
import SiteFooter from './components/SiteFooter'

const LOGO_SRC = '/images/landing-v2/logo.png'
const QR_CODE_SRC = '/images/landing-v2/qr-code.png'

const LandingPageV2: React.FC = () => {
  const [searchParams] = useSearchParams()
  const queryString = searchParams.toString()
  const source = searchParams.get('source')
  const [storeClickURL, setStoreClickURL] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    generateOneLinkClickURL().then(clickURL => {
      if (!cancelled && clickURL) setStoreClickURL(clickURL)
    })
    return () => {
      cancelled = true
    }
  }, [queryString])

  // Scoped to this page only, and reverted on unmount so other routes are unaffected.
  useEffect(() => {
    const root = document.documentElement
    const previousScrollBehavior = root.style.scrollBehavior
    const previousScrollPadding = root.style.scrollPaddingTop
    const previousBodyOverflowX = document.body.style.overflowX
    root.style.scrollBehavior = 'smooth'
    root.style.scrollPaddingTop = '96px'
    // The hero collage intentionally bleeds past the viewport edge; contain it on the real
    // scrolling root rather than a wrapper div, which would break position: sticky below.
    document.body.style.overflowX = 'hidden'
    return () => {
      root.style.scrollBehavior = previousScrollBehavior
      root.style.scrollPaddingTop = previousScrollPadding
      document.body.style.overflowX = previousBodyOverflowX
    }
  }, [])

  const appStoreURL = storeClickURL ?? buildFallbackAppStoreURL(source)
  const playStoreURL = storeClickURL ?? buildFallbackPlayStoreURL(source)
  const getAppHref = storeClickURL ?? IVY_ONELINK_TEMPLATE_URL

  return (
    <div className="v2-landing">
      <SiteHeader logoSrc={LOGO_SRC} getAppHref={getAppHref} />
      <Hero qrCodeSrc={QR_CODE_SRC} getAppHref={getAppHref} />
      <HowItWorksSection />
      <ForSinglesSection />
      <ForVenuesSection />
      <TrustSection />
      <AroundChicagoSection />
      <AboutSection />
      <DownloadSection getAppHref={getAppHref} appStoreURL={appStoreURL} playStoreURL={playStoreURL} qrCodeSrc={QR_CODE_SRC} />
      <SiteFooter logoSrc={LOGO_SRC} />
    </div>
  )
}

export default LandingPageV2
